import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-generic-confirmation-dialog',
    templateUrl: './generic-confirmation-dialog.component.html',
    styleUrls: ['./generic-confirmation-dialog.component.scss'],
    standalone: false
})
export class GenericConfirmationDialogComponent {
  title: string;
  message: string;
  messageHtml?: string;
  dialogRef: MatDialogRef<GenericConfirmationDialogComponent>;
  
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class ConfirmDialogModel {
  constructor(public title: string, public message: string) { }
}
